import { Select } from "@rio-cloud/rio-uikit";

import { errorClass, renderErrorIcon } from "./formFeedback";

import type { ReactNode } from "react";
import type { SelectOption } from "@rio-cloud/rio-uikit";

export type Complement = {
  id: string;
  type: string;
  volume: string;
  value: string;
  unitPrice: string;
};

let ultimoComplementoId = 0;

export const criarComplementoId = () => {
  ultimoComplementoId += 1;
  return `complemento-${ultimoComplementoId}`;
};

export type ComplementLabels = {
  type: string;
  volume: string;
  value: string;
  unitPrice: string;
  selectPlaceholder: string;
};

type ComplementListProps = {
  complements: Complement[];
  errors: Record<string, string>;
  typeOptions: SelectOption[];
  labels: ComplementLabels;
  onChangeType: (index: number, typeId: string) => void;
  onChangeVolume: (index: number, volume: string) => void;
  onChangeValue: (index: number, value: string) => void;
  renderRemoveButton: (index: number) => ReactNode;
};

const ComplementList = ({
  complements,
  errors,
  typeOptions,
  labels,
  onChangeType,
  onChangeVolume,
  onChangeValue,
  renderRemoveButton,
}: ComplementListProps) => (
  <>
    {complements.map((complement, index) => {
      const typeErrorKey = `${index}_type`;
      const volumeErrorKey = `${index}_volume`;
      const valueErrorKey = `${index}_value`;

      return (
        <div key={complement.id} className="padding-15 border border-color-light rounded-small margin-bottom-15">
          <div className={`form-group ${errorClass(errors[typeErrorKey])}`}>
            <label>{labels.type}</label>
            <Select
              options={typeOptions}
              value={complement.type ? [complement.type] : []}
              onChange={(val) => onChangeType(index, val?.id || "")}
              placeholder={labels.selectPlaceholder}
              useClear
            />
            {renderErrorIcon(errors[typeErrorKey])}
            <span className="help-block">
              <span>{errors[typeErrorKey]}</span>
            </span>
          </div>

          <div className={`form-group ${errorClass(errors[volumeErrorKey])}`}>
            <label>{labels.volume}</label>
            <div className="input-group">
              <span className="input-group-addon">L</span>
              <input
                type="text"
                className="form-control"
                value={complement.volume}
                onChange={(e) => onChangeVolume(index, e.target.value)}
                placeholder="10"
              />
            </div>
            {renderErrorIcon(errors[volumeErrorKey])}
            <span className="help-block">
              <span>{errors[volumeErrorKey]}</span>
            </span>
          </div>

          <div className={`form-group ${errorClass(errors[valueErrorKey])}`}>
            <label>{labels.value}</label>
            <div className="input-group">
              <span className="input-group-addon">R$</span>
              <input
                type="text"
                className="form-control"
                value={complement.value}
                onChange={(e) => onChangeValue(index, e.target.value)}
                placeholder="65,00"
              />
            </div>
            {renderErrorIcon(errors[valueErrorKey])}
            <span className="help-block">
              <span>{errors[valueErrorKey]}</span>
            </span>
          </div>

          <div className="form-group">
            <label>{labels.unitPrice}</label>
            <div className="input-group">
              <span className="input-group-addon">R$</span>
              <input type="text" className="form-control" value={complement.unitPrice} readOnly placeholder="6,50" />
            </div>
          </div>

          {renderRemoveButton(index)}
        </div>
      );
    })}
  </>
);

export default ComplementList;
